// extracted by mini-css-extract-plugin
module.exports = {"tooltipLink":"_7s5os","radioInput":"_2ey2Z","text":"_2Mh4A","infoSection":"_2gcYg","label":"pEUlE","licenseName":"_3Y8fQ _2Mh4A","licenseDescription":"_2ilg0 _2Mh4A"};